import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { typeofExpr } from '@angular/compiler/src/output/output_ast';
import { UtilService } from 'src/app/shared/services/util.service';


@Component({
    selector: 'app-modal-solicitud-ajuste-compensacion',
    templateUrl: './modal-solicitud-ajuste-compensacion.component.html'
})
export class ModalSolicitudAjusteCompensacion implements OnInit {
    modalOptions: any;
    accept: string;

    soportes: File[];
    observaciones: string;

    constructor(
        private activeModal: NgbActiveModal,
        private alertService: AlertService,
        private urlService: UrlService,
        private global: GlobalService,
        private spinner: NgxSpinnerService,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.modalOptions = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_SOLICITUD_AJUSTE,
            'SI', 'NO', 'fas fa-save', false, false,
            'Guardar',
            null, 'btn-secondary');
        this.accept = '.pdf';
        this.soportes = [];
    }

    /**
     * Método que permite cerrar el modal cuando se da clic en el botón cerrar (x)
     * @function cerrar
     * @author dfranco@asesoftware.com
     */
    public cerrar() {
        this.activeModal.close();
    }

    /**
     * Método que permite agregar un documento a la solicitud de ajuste
     * @function agregarSoporte
     * @author dfranco@asesoftware.com
     * @param  {type} event Objeto que contiene el archivo seleccionado
     */
    public agregarSoporte(event) {
        if (event.target.files.length > 0) {
            const archivo = event.target.files[0];
            if (archivo && archivo.name.includes('.pdf')) {
                this.soportes.push(archivo);
            }
        }
    }

    /**
     * Método que permite eliminar un documento de la solicitud de ajuste
     * @function eliminarSoporte
     * @author dfranco@asesoftware.com
     * @param soporte Objeto que contiene el elemento a eliminar
     */
    public eliminarSoporte(soporte) {
        const indice = this.soportes.indexOf(soporte);
        if (indice !== -1) {
            this.soportes.splice(indice, 1);
        }
    }

    /**
     * Método que permite iniciar el guardado de la solicitud de compensación
     * @function guardarSolicitud
     * @author dfranco@asesoftware.com
     * @param  {type} event Objeto que contiene la decisión del usuario al mensaje de confirmación
     */
    public guardarSolicitud(event) {
        if (event[0]) {
            if (this.utilService.validarCamposObligatorios(this.observaciones) && this.soportes.length > 0) {
                const data: object = {
                    soportes: this.soportes,
                    observaciones: this.observaciones
                };
                this.activeModal.close(data);
            } else {
                this.alertService.generateAlertError(ConstantesService.MENSAJE_OBSERVACION_OBLIGATORIA_AJUSTE, '');
            }
        }
    }

}